import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { CartProvider } from './contexts/CartContext';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ForgotUserId from './pages/ForgotUserId';
import ResetPassword from './pages/ResetPassword';
import ProductDetail from './pages/ProductDetail';
import CartPage from './pages/CartPage';
import BuyerAddressManager from './pages/BuyerAddressManager';
import BuyerOrdersPage from './pages/BuyerOrdersPage';
import CourierReturnPage from './pages/CourierReturnPage';
import BuyerEmailVerificationPage from './pages/BuyerEmailVerificationPage';
import BuyerPhoneVerificationPage from './pages/BuyerPhoneVerificationPage';
import BuyerNotificationsPage from './pages/BuyerNotificationsPage';
import BuyerProfile from './pages/BuyerProfile';
import BuyerInviteFriends from './pages/BuyerInviteFriends';
import AdminOrdersPage from './pages/AdminOrdersPage';
import AdminReviewManager from './pages/AdminReviewManager';
import AdminContactMessages from './pages/AdminContactMessages';
import AdminNotificationManager from './pages/AdminNotificationManager';
import AdminInviteManager from './pages/AdminInviteManager';
import AdminRefundRequestsPage from './pages/AdminRefundRequestsPage';
import CommunicationTemplateManager from './pages/CommunicationTemplateManager';
import InventoryManagerDashboard from './pages/InventoryManagerDashboard';
import AdministratorDashboard from './pages/AdministratorDashboard';
import SuperUserDashboard from './pages/SuperUserDashboard';
import SuperUserUserManager from './pages/SuperUserUserManager';
import SuperUserPromoManager from './pages/SuperUserPromoManager';
import AdminCategoryManager from './pages/AdminCategoryManager';
import AdminAttributeManager from './pages/AdminAttributeManager';
import ProductManager from './pages/ProductManager';
import GstRateManager from './pages/GstRateManager';
import CostingParameterManager from './pages/CostingParameterManager';
import SupplierManager from './pages/SupplierManager';
import ShipmentManager from './pages/ShipmentManager';
import StoreSettingsManager from './pages/StoreSettingsManager';
import IndiaStateManager from './pages/IndiaStateManager';
import GmcSyncManager from './pages/GmcSyncManager';
import PosPage from './pages/PosPage';
import Unauthorized from './pages/Unauthorized';
import InviteUnsubscribe from './pages/InviteUnsubscribe';
import NotFound from './pages/NotFound';
import ReturnPolicyPage from './pages/ReturnPolicyPage';
import ShippingPolicyPage from './pages/ShippingPolicyPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import { ROLES } from './contexts/AuthContext';
import { StoreSettingsProvider } from './contexts/StoreSettingsContext';
import { NotificationProvider } from './contexts/NotificationContext';
import './App.css';
import Layout from './layout';
// import LightboxGallery from './pages/LightboxGallery';

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <StoreSettingsProvider>
          <NotificationProvider>
            <Router>
              <div className="App">
                <Routes>
            <Route path="/" element={<Layout />} >
            {/* Public routes */}
            <Route index element={<Home />} />
            <Route path="login" element={<Login />} />
            <Route path="register" element={<Register />} />
            <Route path="forgot-password" element={<ForgotPassword />} />
            <Route path="forgot-user-id" element={<ForgotUserId />} />
            <Route path="reset-password" element={<ResetPassword />} />
            <Route path="unauthorized" element={<Unauthorized />} />
            <Route path="invite-unsubscribe" element={<InviteUnsubscribe />} />
            <Route path="courier/return/:token" element={<CourierReturnPage />} />
            <Route path="return-policy" element={<ReturnPolicyPage />} />
            <Route path="shipping-policy" element={<ShippingPolicyPage />} />
            <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
            {/* <Route path="lightboxgallery" element={<LightboxGallery />} /> */}

            {/* Protected routes */}
            <Route
              path="/buyer"
              element={<Navigate to="/" replace />}
            />
            <Route
              path="/buyer/cart"
              element={
                <ProtectedRoute allowedRoles={[ROLES.BUYER]}>
                  <CartPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/buyer/addresses"
              element={
                <ProtectedRoute allowedRoles={[ROLES.BUYER]}>
                  <BuyerAddressManager />
                </ProtectedRoute>
              }
            />
            <Route
              path="/buyer/orders"
              element={
                <ProtectedRoute allowedRoles={[ROLES.BUYER]}>
                  <BuyerOrdersPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/buyer/verify-email"
              element={
                <ProtectedRoute allowedRoles={[ROLES.BUYER]}>
                  <BuyerEmailVerificationPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/buyer/verify-phone"
              element={
                <ProtectedRoute allowedRoles={[ROLES.BUYER]}>
                  <BuyerPhoneVerificationPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/buyer/notifications"
              element={
                <ProtectedRoute allowedRoles={[ROLES.BUYER]}>
                  <BuyerNotificationsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/buyer/profile"
              element={
                <ProtectedRoute allowedRoles={[ROLES.BUYER]}>
                  <BuyerProfile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/buyer/invite-friends"
              element={
                <ProtectedRoute allowedRoles={[ROLES.BUYER]}>
                  <BuyerInviteFriends />
                </ProtectedRoute>
              }
            />
            <Route
              path="/buyer/product/:productId"
              element={<ProductDetail />}
            />
            <Route
              path="/inventory"
              element={
                <ProtectedRoute allowedRoles={[ROLES.INVENTORY_MANAGER]}>
                  <InventoryManagerDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute allowedRoles={[ROLES.ADMINISTRATOR]}>
                  <AdministratorDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/superuser"
              element={
                <ProtectedRoute allowedRoles={[ROLES.SUPER_USER]}>
                  <SuperUserDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/pos"
              element={
                <ProtectedRoute allowedRoles={[ROLES.CASHIER, ROLES.ADMINISTRATOR, ROLES.SUPER_USER]}>
                  <PosPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/superuser/users"
              element={
                <ProtectedRoute allowedRoles={[ROLES.SUPER_USER]}>
                  <SuperUserUserManager />
                </ProtectedRoute>
              }
            />
            <Route
              path="/superuser/promo-codes"
              element={
                <ProtectedRoute allowedRoles={[ROLES.SUPER_USER]}>
                  <SuperUserPromoManager />
                </ProtectedRoute>
              }
            />
            <Route
              path="/categories"
              element={
                <ProtectedRoute allowedRoles={[ROLES.ADMINISTRATOR, ROLES.SUPER_USER]}>
                  <AdminCategoryManager />
                </ProtectedRoute>
              }
            />
            <Route
              path="/attributes"
              element={
                <ProtectedRoute allowedRoles={[ROLES.ADMINISTRATOR, ROLES.SUPER_USER]}>
                  <AdminAttributeManager />
                </ProtectedRoute>
              }
            />
            <Route
              path="/gst-rates"
              element={
                <ProtectedRoute allowedRoles={[ROLES.ADMINISTRATOR, ROLES.SUPER_USER]}>
                  <GstRateManager />
                </ProtectedRoute>
              }
            />
            <Route
              path="/costing-parameters"
              element={
                <ProtectedRoute allowedRoles={[ROLES.ADMINISTRATOR, ROLES.SUPER_USER]}>
                  <CostingParameterManager />
                </ProtectedRoute>
              }
            />
            <Route
              path="/suppliers"
              element={
                <ProtectedRoute allowedRoles={[ROLES.ADMINISTRATOR, ROLES.SUPER_USER]}>
                  <SupplierManager />
                </ProtectedRoute>
              }
            />
            <Route
              path="/shipments"
              element={
                <ProtectedRoute allowedRoles={[ROLES.INVENTORY_MANAGER, ROLES.ADMINISTRATOR, ROLES.SUPER_USER]}>
                  <ShipmentManager />
                </ProtectedRoute>
              }
            />
            <Route
              path="/products"
              element={
                <ProtectedRoute allowedRoles={[ROLES.INVENTORY_MANAGER, ROLES.ADMINISTRATOR, ROLES.SUPER_USER]}>
                  <ProductManager />
                </ProtectedRoute>
              }
            />
            <Route
              path="/orders"
              element={
                <ProtectedRoute allowedRoles={[ROLES.ADMINISTRATOR, ROLES.SUPER_USER]}>
                  <AdminOrdersPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/refund-requests"
              element={
                <ProtectedRoute allowedRoles={[ROLES.ADMINISTRATOR, ROLES.SUPER_USER]}>
                  <AdminRefundRequestsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/reviews-admin"
              element={
                <ProtectedRoute allowedRoles={[ROLES.ADMINISTRATOR, ROLES.SUPER_USER]}>
                  <AdminReviewManager />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/invitees"
              element={
                <ProtectedRoute allowedRoles={[ROLES.ADMINISTRATOR, ROLES.SUPER_USER]}>
                  <AdminInviteManager />
                </ProtectedRoute>
              }
            />
            <Route
              path="/communication-templates"
              element={
                <ProtectedRoute allowedRoles={[ROLES.ADMINISTRATOR, ROLES.SUPER_USER]}>
                  <CommunicationTemplateManager />
                </ProtectedRoute>
              }
            />
            <Route
              path="/store-settings"
              element={
                <ProtectedRoute allowedRoles={[ROLES.ADMINISTRATOR, ROLES.SUPER_USER]}>
                  <StoreSettingsManager />
                </ProtectedRoute>
              }
            />
            <Route
              path="/gmc-sync"
              element={
                <ProtectedRoute allowedRoles={[ROLES.ADMINISTRATOR, ROLES.SUPER_USER]}>
                  <GmcSyncManager />
                </ProtectedRoute>
              }
            />
            <Route
              path="/contact-messages"
              element={
                <ProtectedRoute allowedRoles={[ROLES.ADMINISTRATOR, ROLES.SUPER_USER]}>
                  <AdminContactMessages />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/notifications"
              element={
                <ProtectedRoute allowedRoles={[ROLES.ADMINISTRATOR, ROLES.SUPER_USER]}>
                  <AdminNotificationManager />
                </ProtectedRoute>
              }
            />
            <Route
              path="/india-states"
              element={
                <ProtectedRoute allowedRoles={[ROLES.ADMINISTRATOR, ROLES.SUPER_USER]}>
                  <IndiaStateManager />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<NotFound />} />
            </Route>
                </Routes>
              </div>
            </Router>
          </NotificationProvider>
      </StoreSettingsProvider>
    </CartProvider>
  </AuthProvider>
  );
}

export default App;
